import React from 'react';
import { useInView, motion } from 'framer-motion';
import * as S from './styles';

const steps = [
  {
    num: 1,
    title: 'Baixe o App',
    text: 'Disponível gratuitamente na Play Store. Instale e crie sua conta com um e-mail em menos de 2 minutos.',
  },
  {
    num: 2,
    title: 'Crie sua Excursão',
    text: 'Preencha destino, data, capacidade e preço. Cadastre os passageiros e o Excursei cuida do resto.',
  },
  {
    num: 3,
    title: 'Gerencie com Facilidade',
    text: 'Acompanhe tudo em tempo real: pagamentos, documentos e eventos. Seu negócio mais organizado do que nunca.',
  },
];

export const HowItWorksSection: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <S.Section id="como-funciona" ref={ref}>
      <S.Header>
        <motion.span
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <S.SectionTag>Como Funciona</S.SectionTag>
        </motion.span>
        <S.SectionTitle
          as={motion.h2}
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Comece em 3 passos simples
        </S.SectionTitle>
        <motion.p
          initial={{ opacity: 0, y: 26 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <S.SectionSub>
            Sem burocracia. Sem treinamento. Em minutos você já está organizado.
          </S.SectionSub>
        </motion.p>
      </S.Header>
      <S.Grid>
        <S.Connector />
        {steps.map((step, i) => (
          <motion.div
            key={step.num}
            initial={{ opacity: 0, y: 26 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 + i * 0.09 }}
          >
            <S.Step>
              <S.StepCircle>{step.num}</S.StepCircle>
              <S.StepTitle>{step.title}</S.StepTitle>
              <S.StepText>{step.text}</S.StepText>
            </S.Step>
          </motion.div>
        ))}
      </S.Grid>
    </S.Section>
  );
};
